import { useGlobalStore } from '@/stores';
import { get } from './Http';

/**
 * Navigates to help file location
 */
const goToHelp = async (replaceLastURLElement = null) => {
    const store = useGlobalStore();
    const { helpLink, defaultLocale, themeName } = store;
    const locale = store.requestParams ? store.requestParams.lang : 'en';
    const themes = [];
    if (themeName !== '') {
        themes.push(themeName);
    }
    if (themeName !== 'default') {
        themes.push('default');
    }

    let links = [];
    themes.forEach((theme) => {
        links.push(helpLink.replace('{lng}', locale).replace('{theme}', theme));
        if (locale.includes('_')) {
            links.push(helpLink.replace('{lng}', locale.split('_')[0]).replace('{theme}', theme));
        }
        links.push(helpLink.replace('{lng}', defaultLocale).replace('{theme}', theme));
    });

    links = [...new Set(links)];

    let found = false;
    for (let i = 0; i < links.length; i++) {
        let link = links[i];

        if (replaceLastURLElement !== null) {
            link = `${link.substring(0, link.lastIndexOf('/'))}/${replaceLastURLElement}`;
        }

        await get(link, () => (found = true));
        if (found) {
            window.open(link);
            break;
        }
    }
};

export { goToHelp };
